<form [formGroup]="form()">
  <ngx-recaptcha2 #captchaElem
                  siteKey="6LeMhXsaAAAAAJGLeSpf_zsNhZkZm8edYQwKXIwK"
                  [formControlName]="captchaFieldName()">
  </ngx-recaptcha2>
</form>
